export var formatOrdinalEN = function (value) {
    var valueNumber = Number(value);
    if (valueNumber > 10 && valueNumber < 14) {
        return "".concat(valueNumber, "th");
    }
    switch (valueNumber % 10) {
        case 1:
            return "".concat(valueNumber, "st");
        case 2:
            return "".concat(valueNumber, "nd");
        case 3:
            return "".concat(valueNumber, "rd");
        default:
            return "".concat(valueNumber, "th");
    }
};
export var formatOrdinalDE = function (value) { return "".concat(value, "."); };
export var formatOrdinalSA = function (value) { return "".concat(value); };
export var formatOrdinalTW = function (value) {
    return "".concat(value.replace(/日/g, '號'));
};
//# sourceMappingURL=formatOrdinal.js.map